enum ePaymentType {
  LINK = "link",
  CARD_READER = "card-reader",
  CARD_INPUT = "card-input",
  CASH_PAID = "cash-paid",
  CASH_UNPAID = "cash-unpaid",
  NOT_PAYED = "not-payed",
}

export type PaymentType = (typeof ePaymentType)[keyof typeof ePaymentType]

export default ePaymentType
